import { useState, useCallback } from 'react';

const useModals = () => {
  const [showAttendanceModal, setShowAttendanceModal] = useState(false);
  const [showEventAttendeesModal, setShowEventAttendeesModal] = useState(false);
  const [showEventDetailModal, setShowEventDetailModal] = useState(false);

  const [showReportsModal, setShowReportsModal] = useState(false);
  const [activeTab, setActiveTab] = useState('info');

  const openAttendanceModal = useCallback(() => {
    setShowAttendanceModal(true);
  }, []);

  const closeAttendanceModal = useCallback(() => {
    setShowAttendanceModal(false);
  }, []);

  const openEventAttendeesModal = useCallback(() => {
    setShowEventAttendeesModal(true);
  }, []);

  const closeEventAttendeesModal = useCallback(() => {
    setShowEventAttendeesModal(false);
  }, []);

  const openEventDetailModal = useCallback(() => {
    setShowEventDetailModal(true);
    setActiveTab('info');
  }, []);

  const closeEventDetailModal = useCallback(() => {
    setShowEventDetailModal(false);
  }, []);



  const openReportsModal = useCallback(() => {
    setShowReportsModal(true);
  }, []);

  const closeReportsModal = useCallback(() => {
    setShowReportsModal(false);
  }, []);

  const changeTab = useCallback((tabKey) => {
    setActiveTab(tabKey);
  }, []);

  const closeAllModals = useCallback(() => {
    setShowAttendanceModal(false);
    setShowEventAttendeesModal(false);
    setShowEventDetailModal(false);
    setShowReportsModal(false);
  }, []);

  return {
    // State
    showAttendanceModal,
    showEventAttendeesModal,
    showEventDetailModal,
    showReportsModal,
    activeTab,
    
    // Actions
    openAttendanceModal,
    closeAttendanceModal,
    openEventAttendeesModal,
    closeEventAttendeesModal,
    openEventDetailModal,
    closeEventDetailModal,
    openReportsModal,
    closeReportsModal,
    changeTab,
    closeAllModals
  };
};

export default useModals;